// トレーニング履歴（月次）.
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { JS_VOID } from '../../utils/commonUtil';
import { MDate } from '../../utils/dateUtil';
import { MonthlyCountData } from '../../utils/MonthlyCountData';
import * as TrainingConst from '../../constants/Training';
import { TrainingMenu, TypeVariables } from '../../constants/Training';
import * as Enumerable from 'linq';

// テーブルのprops
interface TableProps extends React.Props<{}> {
  // 0~3のタイプ.
  // history_monthly_tables, history_monthly_date_tablesのインデックスにも使用する.
  myNo: number;

  // 日数.
  historyMonthlyDateTables: any[];

  // 月間テーブル履歴.
  historyMonthlyTables: any[];

  // trueのデータ数.
  numOfTrueDate: number;

  // トレーニング名.
  trainingMenus: TrainingMenu[];

  // 種類.
  type: TrainingConst.TYPE;
}

// 各テーブル生成用.
class Table extends React.Component<TableProps, {}> {
  // 各テーブル用定数.
  typeVariables: TypeVariables[] = [
    {comp: 0, prefix: '1st'},
    {comp: 9, prefix: '2nd'},
    {comp: 18, prefix: '3rd'},
    {comp: 27, prefix: '4th'},
  ];

  componentWillMount() {
    // do something
  }

  render() {
    // history_monthly_tablesなどのインデックスにも使用する.
    const myNo: number = this.props.myNo;

    // 比較用数.
    const comp: number = this.typeVariables[this.props.myNo].comp;

    // key用prefix.
    const prefix: string = this.typeVariables[myNo].prefix;

    if ((this.props.numOfTrueDate > comp) === false) {
      return (null);
    }

    return (
      <table className="tblStyle02">
        <colgroup>
          <col/>
          <col span={8} />
        </colgroup>
        <tbody>
          {this.props.historyMonthlyTables[myNo].map((history: number[], index: number) => {
            // ADLでのスキップ.
            // x 105(101 + 4): 更衣着脱衣(上半身).
            // x 106(101 + 5): 更衣着脱衣(靴下).
            if (this.props.type === TrainingConst.TYPE.ADL && TrainingConst.SKIP_ADL_IDX.indexOf(index) >= 0) {
              return;
            }

            return <tr key={index}>
            {this.props.trainingMenus.map((trainingMenu: TrainingMenu, i: number) => {
              // 1を引いてるのはロコモのidが1開始.
              if (this.props.type === TrainingConst.TYPE.Locomo && trainingMenu.id - 1 === index
                // ADL101開始.
                || this.props.type === TrainingConst.TYPE.ADL && trainingMenu.id - 101 === index) {
                const key = `${prefix}TableHeader${i}`;
                return <th key={key} scope="row">
                {trainingMenu.name}
                </th>;
              }

              // 該当しないときはパス
              return;
            })}
            {history.map((data: number, i: number) => {
              const key = `${prefix}TableBody${i}`;
              if (data > 0) {
                return <td key={key}><p>{data}回</p></td>;
              } else {
                return <td key={key}><p>- </p></td>;
              }
            })}
            </tr>;
          })}
          <tr>
            <th>&nbsp;</th>
            {this.props.historyMonthlyDateTables[myNo].map((date: number, i: number) => {
              const key = `${prefix}TableDateList${i}`;
              return <td key={key}>{date}日</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  }
}

// ローディング中のダミー・トレーニング履歴（月次）props.
interface DummyMonthlyHistoryProps extends React.Props<{}> {
  // 親からの引き渡し用.
  mDate: MDate;
}

// ローディング中のダミー・トレーニング履歴（月次）.
export class DummyMonthlyHistory extends React.Component<DummyMonthlyHistoryProps, {}> {
  yearSelected: string;
  monthSelected: string;

  render() {
    const mDate: MDate = this.props.mDate;
    this.yearSelected = mDate.year;
    this.monthSelected = mDate.month;

    return (
      <section id="sec02">
        <h2 className="ttlStyle01">トレーニング履歴（月次）</h2>
        <div className="inner">
          <div className="calendarHeader">
            <div className="dateArea">
              <div className="date">
                {this.yearSelected}<span className="year">年</span>
                {this.monthSelected}<span>月</span>
              </div>
              <div className="btn left">
                <a/>
              </div>
              <div className="btn right">
                <a/>
              </div>
            </div>
            <div className="btnStyle05">
              <a>比較する</a>
            </div>
          </div>
          <div><p>この月はデータがありません。</p></div>
        </div>
      </section>
    );
  }
}

// トレーニング履歴（月次）props.
interface MonthlyHistoryProps extends React.Props<{}> {
  trainingMenus: TrainingMenu[];

  // response内容.
  history: any;

  // 親からの引き渡し用.
  mDate: MDate;

  // 種類.
  type: TrainingConst.TYPE;
}

/**
 * トレーニング履歴（月次）.
 *
 * @export
 * @class MonthlyHistory
 * @extends {React.Component<MonthlyHistoryProps, {}>}
 */
export default class MonthlyHistory extends React.Component<MonthlyHistoryProps, {}> {
  yearSelected: string;
  monthSelected: string;
  mDate: MDate;

  static get contextTypes() {
    // 親のLocomoコンポーネントと橋渡しするcontext.
    return {
      // 左右.
      callbackParent: PropTypes.func,
      // ステート変更.
      changeState: PropTypes.func,
    };
  }

  componentWillMount() {
    // ここは左、右ボタンの際も呼ばれる.
    this.mDate = this.props.mDate;
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;
  }

  // 比較するをクリックしたときの処理.
  toLocomoCompare = () => {
    // 親contextのメソッド.
    this.context.changeState(TrainingConst.COMPARE_STATE);
  }

  // 左をクリックしたときの処理.
  minusMonthly = (yearSelected: string, monthSelected: string) => {
    // 先月.
    this.mDate.setPreMonth();

    // 親contextのメソッド.
    this.context.callbackParent(this.mDate.yearmonth);
  }

  // 右をクリックしたときの処理.
  plusMonthly = (yearSelected: string, monthSelected: string) => {
    // 次の月.
    this.mDate.setNextMonth();

    // 親contextのメソッド.
    this.context.callbackParent(this.mDate.yearmonth);
  }

  render() {
    const monthlyCountData: MonthlyCountData = new MonthlyCountData(this.props.type);

    // データ有無表示用.
    const dataSize: number = monthlyCountData.dataSize(this.props.history);

    // 配列にresponseデータを格納.
    monthlyCountData.insertData(this.props.history);

    // 日付に記録があるかどうか.
    const historyDateFlag = monthlyCountData.dateFlag;

    // 表示用に、テーブルを最大4つ用意して、配列に格納したresponseデータを格納していく.
    const NUM_TABLES = 4;

    let numRows = 0;
    if (this.props.type === TrainingConst.TYPE.Locomo) {
      // 項目数.
      numRows = TrainingConst.MAX_LOCOMO_CNT;
    } else if (this.props.type === TrainingConst.TYPE.ADL) {
      // 項目数.
      numRows = TrainingConst.MAX_ADL_CNT;
    }

    // 日数が横に並ぶ列の数（9日分）.
    const NUM_COLS = 9;
    const mData = monthlyCountData.divideHistoryMonthTables(
      historyDateFlag, monthlyCountData.historyTable, numRows, NUM_COLS, NUM_TABLES);

    const numOfTrueDate = mData[0].num_td;

    const historyMonthlyTables: number[][][] = [];
    const historyMonthlyDateTables: number[][] = [];

    // 配列分割分.
    for (let i = 0; i < NUM_TABLES; i++) {
      historyMonthlyTables[i] = mData[i].h_month;
      historyMonthlyDateTables[i] = mData[i].h_month_date;
    }

    return (
      <section id="sec02">
        <h2 className="ttlStyle01">トレーニング履歴（月次）</h2>
        <div className="inner">
          <div className="calendarHeader">
            <div className="dateArea">
              <div className="date">
                {this.yearSelected}<span className="year">年</span>
                {this.monthSelected}<span>月</span>
              </div>
              <div className="btn left">
                <a href={JS_VOID} onClick={event => this.minusMonthly(this.yearSelected, this.monthSelected)} />
              </div>
              <div className="btn right">
                <a href={JS_VOID} onClick={event => this.plusMonthly(this.yearSelected, this.monthSelected)} />
              </div>
            </div>
            <div className="btnStyle05">
              <a onClick={event => this.toLocomoCompare()}>比較する</a>
            </div>
              {/* <div className="btnStyle03">
                <a href={JS_VOID}>カレンダー</a>
              </div> */}
          </div>
          { // データ数でのif
            (() => {
              if (dataSize === 0) {
                return <div><p>この月はデータがありません。</p></div>;
              } else if (dataSize === -1) {
                return <div><p>読み込み中</p></div>;
              } else if (dataSize === -2) {
                // actions/MoffAPIのmonthlyData, startData, endDataをnullにしてtest.
                return <div><p>データ取得に失敗した可能性があります。再読込してください。</p></div>;
              } else {
                return<div>
                  {
                    // 1st to 4th.
                    Enumerable.range(0, 3)
                      .select<JSX.Element>(
                        (i) => {
                          return <Table
                            key={`MonthlyHistoryTable${i}`}
                            type={this.props.type}
                            myNo={i}
                            historyMonthlyDateTables={historyMonthlyDateTables}
                            historyMonthlyTables={historyMonthlyTables}
                            numOfTrueDate={numOfTrueDate}
                            trainingMenus={this.props.trainingMenus}
                          />;
                        }
                      ).toArray()
                  }
                </div>;
              }
            })()
          }
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/MonthlyHistory.tsx